import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import ReactDOM from "react-dom";
import useFilterRows from "helpers/customHooks/useFilterRows";
import ConfirmationModal from "components/ConfirmationModal/ConfirmationModal";
import AppLayoutWrapFull from "components/AppLayoutWrapFull";
import PageHeader from "components/PageHeader/PageHeader";
import PageHeaderActions from "components/PageHeader/components/PageHeaderActions/PageHeaderActions";
import Container from "components/Container/Container";
import FullDataTable from "components/DataTable/FullDataTable";
import TableDefAffiliates from "table-defs/TableDefAffiliates";
// import NotifyAffiliatesModal from "./components/NotifyAffiliatesModal/NotifyAffiliatesModal";
import BulkUploadModal from "./components/BulkUploadModal/BulkUploadModal";
import VendorAuditModal from "./components/VendorAuditModal/VendorAuditModal";
import {
    loadAffiliatesAction,
    deleteAffiliateAction,
    notifyAffiliateAction,
    sendVendorAuditAffiliateAction,
    readVendorAuditAffiliateAction,
    sendConfAgreementAffiliateAction,
    approveAffiliateAction,
    declineAffiliateAction,
    sendBaAgreementAffiliateAction,
    submitEditAffiliateFormAction,
} from "store/actions/Actions";

import { setSelectedRows, toggleDropdowns } from "helpers/utils";

const Affiliates = props => {
    const { AffiliatesReducer, loadAffiliatesAction } = props;
    useEffect(() => {
        if (!AffiliatesReducer.affiliates) {
            loadAffiliatesAction();
        }
    }, [AffiliatesReducer.affiliates, loadAffiliatesAction]);

    const openAddNewAffiliate = () => {
        props.history.push("/achieve/affiliates/add");
        return;
    }

    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const renderConfirmModal = () => {
        return ReactDOM.createPortal(
            <ConfirmationModal
                data={showConfirmModal}
                setShowModal={setShowConfirmModal}
            />,
            document.getElementById('modal-root'),
        );
    };

    // ##############################################
    const noFilters = {
        text: "",
        type: "",
        "last-action": "",
        status: "",
        role: "",
        site: ""
    };
    const [filters, setFilters] = useState(noFilters);
    const setFilter = filterName => e => {
        setFilters({
            ...filters,
            [filterName]:
                e.target.type === "checkbox"
                    ? e.target.checked
                    : e.target.value || ((e.target && e.target.attributes && e.target.attributes.value && e.target.attributes.value.value) || '')
        });
    };
    const filteredRows = useFilterRows(filters, AffiliatesReducer.affiliates);
    // ##############################################

    const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);
    const [showVendorAuditModal, setVendorAuditModal] = useState(false);

    // const bulkUpload = () => console.log("open bulk upload screen");
    // const editAffiliate = id => props.history.push("/");

    // Used to close the dropdown when clicking outside of it if it's open
    const typeDropdownRef = React.createRef();
    const lastActionDropdownRef = React.createRef();
    const statusDropdownRef = React.createRef();
    const chooseActionDropdownRef = React.createRef();

    const [selectedAffiliateIds, setSelectedAffiliateIds] = useState([]);
    const selectedIds = selectedAffiliateIds.map(item => item.id);
    return (
        <AppLayoutWrapFull
            onClick={toggleDropdowns([
                typeDropdownRef,
                lastActionDropdownRef,
                statusDropdownRef,
                chooseActionDropdownRef
            ])}
        >
            <div id="modal-root"></div>
            <PageHeader showStats={true}>
                <PageHeaderActions
                    primaryButtonText="ADD AFFILIATE"
                    primaryButtonHandler={openAddNewAffiliate}
                    secondaryButtonText="BULK UPLOAD"
                    secondaryButtonHandler={() =>
                        setShowBulkUploadModal(!showBulkUploadModal)
                    }
                    searchHandler={e =>
                        setFilters({ ...filters, text: e.target.value || "" })
                    }
                    searchValue={filters.text}
                    statusDropdownRef={statusDropdownRef}
                    chooseActionDropdownRef={chooseActionDropdownRef}
                    chooseAction={[
                        {
                            actionName: "Notify Selected",
                            actionHandler: () => {
                                props.notifyAffiliateAction({ items: selectedIds });
                            }
                        },
                        {
                            actionName: "Approve Selected",
                            actionHandler: () => {
                                props.approveAffiliateAction({ items: selectedIds });
                            }
                        },
                        {
                            actionName: "Decline Selected",
                            actionHandler: () => {
                                props.declineAffiliateAction({ items: selectedIds });
                            }
                        },
                        {
                            actionName: "Send Vendor Audit to Selected",
                            actionHandler: () => {
                                props.sendVendorAuditAffiliateAction({ items: selectedIds });
                            }
                        },
                        {
                            actionName: "Send BA Agreement to Selected",
                            actionHandler: () => {
                                props.sendBaAgreementAffiliateAction({ items: selectedIds })
                            }
                        },
                        {
                            actionName: "Send Confidentiality Agreement to Selected",
                            actionHandler: () => {
                                props.sendConfAgreementAffiliateAction({ items: selectedIds })
                            }
                        },
                        {
                            actionName: "Delete Selected",
                            actionHandler: () => {                                

                                const idCount = selectedIds.length;

                                if (idCount > 0) {
                                    setShowConfirmModal({
                                        title: 'Delete selected affiliates',
                                        question: idCount === 1 ? 
                                            `Are you sure you want to delete the selected affiliate?` : 
                                            `Are you sure you want to delete ${idCount} selected affiliates?`,
                                        confirmAction: () => {
                                            props.deleteAffiliateAction({ items: selectedIds });
                                        },
                                    });
                                } else {
                                    setShowConfirmModal({
                                        type: 'simple',
                                        title: 'Nothing selected',
                                        question: `Please select affiliates to be deleted.`,
                                    });
                                }
                            }
                        }
                    ]}
                    type={{
                        onChange: setFilter("type"),
                        options: [
                            "All",
                            "Business Associate",
                            "Confidentiality"
                        ]
                    }}
                    typeDropdownRef={typeDropdownRef}
                    lastAction={{
                        onChange: setFilter("last-action"),
                        options: [
                            "All",
                            "Questionnaire completed",
                            "Agreement sent",
                            "Agreement attested",
                            "Questionnaire awaiting assignment",
                            "Questionnaire reviewed & attested",
                            "Affiliate created"
                        ]
                    }}
                    lastActionDropdownRef={lastActionDropdownRef}
                    status={{
                        onChange: setFilter("status"),
                        options: ["All", "Approved", "Declined", "Under Review"]
                    }}
                    resetFilters={() => {
                        setFilters(noFilters);
                    }}
                    filters={filters}
                />
            </PageHeader>
            <Container wide fluid>
                {showVendorAuditModal &&
                    <VendorAuditModal setShowModal={setVendorAuditModal} />
                }
                {showBulkUploadModal &&
                    <BulkUploadModal setShowModal={setShowBulkUploadModal} />
                }
                {AffiliatesReducer.affiliates &&
                <FullDataTable
                    rowsData={filteredRows}
                    definitions={TableDefAffiliates}
                    onChangeVisibility={() => false}
                    // onChangeRowSelect={({ selectedRows }) =>
                    //   this.onChangeRowSelect({ selectedRows })
                    // }

                    onRowClick={function(e) {
                        if (
                            e.currentTarget.classList.contains("col-actions") ||
                            e.currentTarget.classList.contains(
                                "col-row-selector"
                            )
                        )
                            return;
                        props.history.push(`/achieve/affiliates/edit?id=${this.props.rowData.id}`);
                    }}
                    setSelectedRows={setSelectedRows(["id"], setSelectedAffiliateIds)}
                    customTableProps={{
                        edit: ({ id }) => props.history.push(`/achieve/affiliates/edit?id=${id}`),
                        approve: ({ id }) => {
                            props.approveAffiliateAction({ items: [id] });
                        },
                        decline: ({ id }) => {
                            props.declineAffiliateAction({ items: [id] });
                        },
                        notify: ({ id }) => {
                            props.notifyAffiliateAction({ items: [id] })
                        },
                        delete: ({ id, name }) => {
                            setShowConfirmModal({
                                title: 'Delete the affiliate',
                                question: `Are you sure you want to remove the affiliate "${name}"`,
                                confirmAction: () => {
                                    props.deleteAffiliateAction({ items: [id] });
                                },
                            });
                        },
                        read_vendor_audit: ({ id }) => {
                            setVendorAuditModal(true);
                            props.readVendorAuditAffiliateAction({ affiliate: id });
                        },
                        send_vendor_audit: ({ id }) => {
                            props.sendVendorAuditAffiliateAction({ items: [id] });
                        },
                        send_ba_agreement: ({ id }) => {
                            props.sendBaAgreementAffiliateAction({ items: [id] });
                        },
                        send_confidentiality_agreement: ({ id }) => {
                            props.sendConfAgreementAffiliateAction({ items: [id] });
                        },
                    }}
                />
                }
                {showConfirmModal && renderConfirmModal()}
            </Container>
        </AppLayoutWrapFull>
    );
};

const mapStateToProps = state => ({
    AffiliatesReducer: state.AffiliatesReducer
});

const mapDispatchToProps = {
    loadAffiliatesAction,
    deleteAffiliateAction,
    notifyAffiliateAction,
    sendVendorAuditAffiliateAction,
    readVendorAuditAffiliateAction,
    approveAffiliateAction,
    declineAffiliateAction,
    sendBaAgreementAffiliateAction,
    sendConfAgreementAffiliateAction,
    submitEditAffiliateFormAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(Affiliates);
